import { createSelector } from "reselect"
import { get, pick, noop } from "lodash"
import { getIsOpPro } from "modules/account-root/selectors"
import { Creators } from "../model"
import { computeColumns, makeComputeAssetAnalyticsColumns, betaColumnFilter } from "helpers/assets"
import { getRawSort, getSelectedSubView, getModelId, getDisableColumnClick, getSelectedMetricType } from "."
import { getFactorsColumns } from "./factorColumns"
import { getMissingDataFiles } from "selectors/missingDataFiles"
import { getSelectedViewIsContentSet } from "selectors/contentSets"
import { getSelectedView } from "selectors/assets"
import { coalesce } from "helpers/selectors"
import { getSelectedModelName } from "modules/portfolio-root/selectors/portfolios"
import { getPortfolioBetaInstrument } from "modules/portfolio-root/selectors/beta-instrument"
import { getCategories } from "selectors/factors"

const getRawGMV = state => get(state, "global.data.intradayComposition.data.model.intradaySimulationBatch.composition.0.gmv")
const getRawGroupedGMV = state => get(state, "global.data.intradayGroupedComposition.data.model.intradaySimulationBatch.composition.0.gmv")
const getRawReferenceEquity = state => get(state, "global.data.intradayComposition.data.model.intradaySimulationBatch.composition.0.referenceEquity")
const getRawGroupedReferenceEquity = state => get(state, "global.data.intradayGroupedComposition.data.model.intradaySimulationBatch.composition.0.referenceEquity")

const getGMV = createSelector(
  [getRawGMV, getRawGroupedGMV],
  coalesce,
)

const getReferenceEquity = createSelector(
  [getRawReferenceEquity, getRawGroupedReferenceEquity],
  coalesce,
)

const getRawColumns = createSelector(
  [getGMV, getReferenceEquity, noop, getSelectedMetricType, getSelectedModelName, getPortfolioBetaInstrument],
  computeColumns,
)

const getFilteredColumns = createSelector(
  [getRawColumns],
  (columns) => pick(columns, ["composition", "risk", "marginalContribution", "beta"]),
)

export const getViewColumnsMap = createSelector(
  [getFilteredColumns, getMissingDataFiles, getModelId],
  (columns, missingDataFiles, modelId) => ({
    summary: [
      ...columns.composition,
      ...columns.risk,
      ...betaColumnFilter(columns.beta, missingDataFiles, modelId),
    ],
    beta: [
      ...columns.composition,
      ...betaColumnFilter(columns.beta, missingDataFiles, modelId),
    ],
    exposure: [
      ...columns.composition,
    ],
    risk: [
      ...columns.composition,
    ],
    sensitivity: [
      ...columns.composition,
    ],
    marginal: [
      ...columns.composition,
      ...columns.marginalContribution,
    ],
  }),

)

export const getColumns = createSelector(
  [getViewColumnsMap, getRawSort, getSelectedView, getSelectedSubView, getFactorsColumns, getIsOpPro, getDisableColumnClick, getSelectedViewIsContentSet, getCategories, getSelectedMetricType],
  makeComputeAssetAnalyticsColumns(Creators.itemClick),
)
